import {
  Card,
  CardClose,
  CardHeader,
  CardTitle,
  Tabs,
  TabsList,
  TabsTrigger,
} from '@ais-ui/ui-core';

import React, { useCallback, useState } from 'react';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { FilterList } from './FilterList';
import { ShipLists } from './Shiplists/ShipLists';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';

interface FiltersProps {
  className: string;
}

export const Filters = React.memo(({ className }: FiltersProps) => {
  const { messages } = useLocalization();
  const onExit = useOnMapPanelExit();
  const [tab, setTab] = useState<'filters' | 'shiplists'>('filters');

  const handleTabChange = useCallback((value: string) => {
    setTab(value as 'filters' | 'shiplists');
  }, []);

  return (
    <Card className={cn('flex flex-col', className)}>
      <CardHeader variant="tinted">
        <CardClose onClick={onExit} />
        <div className="space-y-2">
          <CardTitle className="text-lg font-medium text-muted-foreground">
            {messages.filtersTitle}
          </CardTitle>
          <Tabs
            value={tab}
            onValueChange={handleTabChange}
            className="w-full space-y-6 pt-4 h-full flex flex-col"
          >
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger id="filters-tab-button" value="filters">
                Filters
              </TabsTrigger>
              <TabsTrigger id="shiplists-tab-button" value="shiplists">
                Shiplists
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </CardHeader>
      {tab === 'filters' && <FilterList />}
      {tab === 'shiplists' && <ShipLists />}
    </Card>
  );
});

Filters.displayName = 'Filters';
